import {BaseModel, User} from '.'

/**
 * User model
 */
class Auth extends BaseModel {
  // Default attributes that define the "empty" state.
  defaults () {
    return {
      active: false,
      user: new User(),
      auth: {
        access_token: '',
        token_type: ''
      }
    }
  }

  routes () {
    return {
      login: '/auth'
    }
  }

  reset () {
    this.active = false
    this.user = new User()
    this.auth.token_type = ''
    this.auth.access_token = ''
  }

  getAuthHeader () {
    return this.auth.token_type + ' ' + this.auth.access_token
  }

  login (credentials) {
    let method = 'POST'
    let route = this.getRoute('login')
    let url = this.getURL(route)
    let data = JSON.stringify(credentials)

    return this.getRequest({method, url, data}).send().then((rsp) => {
      this.active = true
      this.auth.access_token = rsp.response.data.access_token
      this.auth.token_type = rsp.response.data.token_type
    })
  }
}

export {Auth}



//////////////////
// WEBPACK FOOTER
// ./src/models/Auth.js
// module id = 881
// module chunks = 1